export enum CaseTabs {
    caseInfo = 'caseInfo',
    engagement = 'engagement',
    milestones = 'milestones',
    caseTasks = 'caseTasks',
    caseEvents = 'caseEvents',
    caseNotes = 'caseNotes',
    caseDocuments = 'caseDocuments',
    caseTimeTracking = 'caseTimeTracking',
    invoices = 'invoices',
    insights = 'insights',
    clientPortal = 'clientPortal',
}